<template>
  <div class="dispatcher-main" :key="z">
    <DispatcherPanel />
    <div class="header">
      <span
        class="tag is-white is-rounded is-medium"
        :class="{ 'is-danger': isBusy }"
        @click="togglePause"
      >
        <i v-if="isBusy" class="fa fa-volume-mute" />
        <i v-else class="fa fa-bullhorn has-text-success" />
      </span>
    </div>
  </div>
</template>

<script>
import DispatcherPanel from "@/components/DispatcherPanel.vue";
import { sounds } from "../functions.js";

export default {
  name: "DispatcherMain",
  components: {
    DispatcherPanel,
  },
  // props: {},
  data() {
    return {
      z: 0,
    };
  },
  computed: {
    role() {
      return this.$store.getters.getDispatcherRole;
    },
    isBusy() {
      if (!this.role) return false;
      // return this.role.data.is_busy;
      return this.role.state !== "working";
    },
  },
  activated() {
    this.initialise();
  },
  mounted() {
    // this.$store.subscribe((mutation) => {
    //   if (mutation.type === "setRoles") this.initialise();
    // });
  },
  methods: {
    initialise() {
      this.pollLocation();
    },
    togglePause() {
      if (this.isBusy) {
        var msg = this.$t("driver.notifications-on");
        this.sendPushNotification(msg, this.userID());
        sounds("squawk");
      }
      // default values if notifications are ON
      var onOff = this.$t("on");
      var txt = this.$t("driver.notifications-on");
      var color = this.bulmaColor("success");
      var icon = `<i class='fa fa-bullhorn fa-2x' style='color:${color}'></i>`;
      if (!this.isBusy) {
        onOff = this.$t("off");
        txt = this.$t("driver.notifications-off");
        color = this.bulmaColor("danger");
        icon = `<i class='fa fa-volume-mute fa-2x' style='color:${color}'></i>`;
      }
      this.$swal({
        title: `${this.$t("driver.notifications")}: ${onOff}`,
        html: `${icon}<br><br>${txt}`, //this.$t("driver.notifications-explanation"),
        showConfirmButton: false,
        showCloseButton: true,
      });
      // this.dispatchRoleBusyPatch();
      this.toggleWorkingState();
      // this.z += 1;
    },
    dispatchRoleBusyPatch() {
      this.role.data.is_busy = !this.role.data.is_busy;
      var data = this.role.data; // send all the data back, not just is_busy
      // var payload = { id: this.role.id, data: data };
      var state = this.role.state;
      if (state === "working") state = "not-working";
      else state = "working";
      var payload = { id: this.role.id, data: data, state: state };
      var loader = this.loadingDots();
      this.$store
        .dispatch("updateRoleData", payload) // setRoleIsBusy
        .then((res) => this.console("updateRoleData", res))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    toggleWorkingState() {
      var state = this.role.state;
      if (state === "working") {
        state = "not-working";
        this.role.data.is_busy = true;
      } else {
        state = "working";
        this.role.data.is_busy = false;
      }
      var data = this.role.data; // send all the data back, not just is_busy
      var payload = { id: this.role.id, data: data, state: state };
      this.$store
        .dispatch("updateRoleData", payload) // setRoleIsBusy
        .then((res) => {
          this.console("updateRoleData", res);
          this.updateRoles();
          setTimeout(() => (this.z += 1), 4000);
        })
        .catch((err) => this.apiError(err));
      // .finally(() => );
    },
  },
};
</script>

<style scoped>
.header {
  position: absolute;
  top: 10px;
  right: 66px;
  z-index: 2;
  filter: drop-shadow(2px 2px 2px #666);
}
</style>